import MainLayout from "./MainLayout"
import { Amplify, Auth } from "src/shared/lib/amplify"
import { Authenticator } from "@aws-amplify/ui-react"
import config from "../aws-exports"
import { useEffect, useState } from "react"
import { isFedRampEnvironment } from "src/utils/CommonMethods"

// errorMessage is needed for if a user is disabled via cognito and not via user dynamo fields
const errorMessage = new URLSearchParams(window.location.search).get(
  "error_description"
)

const WrapperLayout = () => {

  const [authUpdated, setAuthUpdated] = useState(false);

  useEffect(() => {
    if (isFedRampEnvironment()) {
      Amplify.configure({
        ...config,
        oauth: {
          ...config.oauth,
          // Force the identity provider to ask for login details again on every
          // "Sign In" instead of silently reusing an existing SSO session.
          // We inject `prompt=login` into the hosted UI authorize URL only
          // (never the sign-out URL).
          urlOpener: (url: string, redirectUrl: string) => {
            const signInUrl =
              url.includes("/oauth2/authorize") && !url.includes("prompt=")
                ? `${url}&prompt=login`
                : url
            const windowProxy = window.open(signInUrl, "_self")
            return windowProxy ? Promise.resolve(windowProxy) : Promise.reject()
          }
        }
      })
      // Use sessionStorage so each browser tab has its own independent auth
      // session. sessionStorage is scoped per-tab, so a new tab won't inherit
      // the existing session and starts fresh.
      Auth.configure({ storage: window.sessionStorage })
    } else {
      Amplify.configure(config)
    }
    Amplify.configure({
      API: {
        graphql_headers: async () => {
          const session = await Auth.currentSession()
          return {
            Authorization: session.getIdToken().getJwtToken()
          }
        }
      }
    })

    setAuthUpdated(true)
  }, [])

  return (<>
    {authUpdated && <Authenticator.Provider>
      <MainLayout errorMessage={errorMessage} />
    </Authenticator.Provider>
    }</>)
}


export default WrapperLayout;